import { FC, SVGProps } from 'react';

export const CodeIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7.11366 7.13633C7.40656 7.42922 7.40656 7.90409 7.11366 8.19699L3.31066 12L7.11366 15.803C7.40656 16.0959 7.40656 16.5708 7.11366 16.8637C6.82077 17.1565 6.3459 17.1565 6.053 16.8637L1.71967 12.5303C1.42678 12.2374 1.42678 11.7626 1.71967 11.4697L6.053 7.13633C6.3459 6.84343 6.82077 6.84343 7.11366 7.13633Z'
			fill='currentColor'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M13.8069 4.77239C14.2087 4.87285 14.4531 5.28005 14.3526 5.6819L11.1026 18.6819C11.0021 19.0837 10.5949 19.3281 10.1931 19.2276C9.79125 19.1271 9.54693 18.7199 9.64739 18.3181L12.8974 5.31809C12.9978 4.91625 13.405 4.67193 13.8069 4.77239Z'
			fill='currentColor'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16.8864 7.13633C17.1793 6.84343 17.6541 6.84343 17.947 7.13633L22.2804 11.4697C22.5732 11.7626 22.5732 12.2374 22.2804 12.5303L17.947 16.8637C17.6541 17.1565 17.1793 17.1565 16.8864 16.8637C16.5935 16.5708 16.5935 16.0959 16.8864 15.803L20.6894 12L16.8864 8.19699C16.5935 7.90409 16.5935 7.42922 16.8864 7.13633Z'
			fill='currentColor'
		/>
	</svg>
);
